import React from 'react'
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Button, Icon, Message, Divider } from 'semantic-ui-react'
import _find from 'lodash/find';
import _ from 'lodash';

import queries from '../../utils/queries'
import ListaServTar from '../../components/deestado/listaservtar';

const ListaInfAdic = ({handleListaInfAdic}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miListaInfAdic" id="miListaInfAdic" onChange={handleListaInfAdic}>
        <option>Seleccionar...</option>
        <option>CONECTIC</option>
        <option>CABLE CAUCA - MORACERO</option>
      </select>
    </div>
  )
};

//dropdown VENDEDORES
const DetalleNivelV = props => {
  return (
      <option dato1={props.elemento.codigoTipoDoc} value={props.elemento.numeroDocum}>{props.elemento.descrRecurso}</option>
  )
};

const ListaV = ({styles, list, handleChange}) => {
  const Nivel1DetalleV = list.map((elemento, _id) => <DetalleNivelV elemento={elemento} key={elemento._id} />);
    return(
        <div>
            <select style={styles.input} className="ui simple selection dropdown fluid" name="venta" id="miListaV" onChange={(ev)=>handleChange(ev, {value: true})}>
            <option style={styles.input} value="">Seleccionar...</option>
              {Nivel1DetalleV}
            </select>
        </div>
    )
};
//Fin dropdown VENDEDORES

//dropdown TIPO VIA 1
const DetalleLista = props => {
  let campo1 = ""
  if(props.seleccLista==="descrTipoVia1"||props.seleccLista==="descrTipoVia2"){
    campo1=props.elemento.descrTipoVia
  }
  if(props.seleccLista==="descrTipoUnd1"||props.seleccLista==="descrTipoUnd2"){
    campo1=props.elemento.descrTipoUnd
  }
  if(props.seleccLista==="descrTiUndMat"){
    campo1=props.elemento.descrTiUndMat
  }
  if(props.seleccLista==="descrUndMat"){
    campo1=props.elemento.descrUndMat
  }

  return (
    <option>{campo1}</option>
  )
};

const Lista = ({styles, seleccLista, list, handleLista4}) => {
  const detalleLista = list.map((elemento, _id) => <DetalleLista elemento={elemento} seleccLista={seleccLista} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name={seleccLista} id={seleccLista} onChange={(ev)=>handleLista4(ev, seleccLista)}>
        <option value="">Seleccionar...</option>
        {detalleLista}
      </select>
    </div>
  )
};
//Fin dropdown TIPO VIA 1

//dropdown DEPARTAMENTOS
const DetalleSelDe = props => {
  return (
    <option dato1={props.elemento.codigoDpto} dato2={props.elemento.codigoDptoDANE} value={props.elemento.codigoDpto}>{props.elemento.descrDpto}</option>
  )
};

const ListaDe = ({styles, handleCiudadDpto, list, codigoCiudadUA, codigoDptoUA}) => {
  const detalleDe = list.map((elemento, _id) => <DetalleSelDe elemento={elemento} key={elemento._id} />);
  let selecc = true
  if(list.length===1){
    selecc = false
  }
  if(codigoCiudadUA==="Todas..."&&codigoDptoUA==="Todos..."){
    return(
      <div>
        {selecc  &&
          <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista" onChange={()=>handleCiudadDpto()}>
            <option value="">Seleccionar...</option>
            {detalleDe}
          </select>
        }
        {!selecc  &&
          <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista">
            {detalleDe}
          </select>
        }
      </div>
    )
  }else{
    return(
      <div>
        {selecc  &&
          <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista" onChange={()=>handleCiudadDpto()}>
            {detalleDe}
          </select>
        }
        {!selecc  &&
          <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista">
            {detalleDe}
          </select>
        }
      </div>
    )
  }
};
//Fin dropdown DEPARTAMENTOS
//dropdown CIUDADES => solo ciudades del departamento seleccionado
const DetDetalleSelCi = props => {
  return(
    <option dato1={props.elemento.codigoCiudad} dato2={props.elemento.codigoCiudadInterno?props.elemento.codigoCiudadInterno:""} dato3={props.elemento.codBarrasRdo?props.elemento.codBarrasRdo:""} dato4={props.elemento.codigoMunicipioDANE?props.elemento.codigoMunicipioDANE:""} dato5={props.elemento.codigoPostalDANE?props.elemento.codigoPostalDANE:""} value={props.elemento.codigoCiudad}>{props.elemento.nombreCiudad}</option>
  )
}

const DetalleSelCi = ({styles, elemento, handleZonaCiudad, codigoCiudadUA}) => {
  // const detDetalleCi = elemento.ciudades.map((elemento, i) => <DetDetalleSelCi styles={styles} elemento={elemento} key={i} />);
  let selecc = true
  if(elemento.ciudades.length===1){
    selecc = false
  }
  let detDetalleCi = []
  if(codigoCiudadUA==="Todas..."){
    detDetalleCi = elemento.ciudades.map((elemento, i) => <DetDetalleSelCi styles={styles} elemento={elemento} key={i} />);
    return (
      <div>
        {selecc  &&
          <select style={styles.input} className="ui simple selection dropdown fluid" name="ciudad" id="miLista1" onChange={()=>handleZonaCiudad()}>
            <option value="">Seleccionar...</option>
            {detDetalleCi}
          </select>
        }
        {!selecc  &&
          <select style={styles.input} className="ui simple selection dropdown fluid" name="ciudad" id="miLista1" onChange={()=>handleZonaCiudad()}>
            {detDetalleCi}
          </select>
        }
      </div>
    )
  }else{
    elemento.ciudades.forEach((elemento1, _id) => {
      if(elemento1.codigoCiudad===codigoCiudadUA){
        let niv3Det = []
        niv3Det.push(elemento1)
        detDetalleCi = niv3Det.map((elemento, i) => <DetDetalleSelCi styles={styles} elemento={elemento} key={i} />);
      }
    })
    return (
      <div>
        {selecc  &&
          <select style={styles.input} className="ui simple selection dropdown fluid" name="ciudad" id="miLista1" onChange={()=>handleZonaCiudad()}>
            {detDetalleCi}
          </select>
        }
        {!selecc  &&
          <select style={styles.input} className="ui simple selection dropdown fluid" name="ciudad" id="miLista1" onChange={()=>handleZonaCiudad()}>
            {detDetalleCi}
          </select>
        }
      </div>
    )
  }
};

const ListaCi = ({styles, handleZonaCiudad, list, argsSelDpto, codigoCiudadUA}) => {
  var detalleCi = []
  let selecc = true
  // console.log(list, argsSelDpto.codigoDpto)
  list.forEach((elemento, _id) => {
    if(elemento.codigoDpto===argsSelDpto.codigoDpto){
      let niv2Det = []
      niv2Det.push(elemento)
      detalleCi = niv2Det.map((elemento, _id) => <DetalleSelCi styles={styles} elemento={elemento}
        key={elemento._id} handleZonaCiudad={handleZonaCiudad} codigoCiudadUA={codigoCiudadUA}/>);
      if(elemento.ciudades.length===1){
        selecc = false
      }
    }
  })
  return(
    <div>
      {(!argsSelDpto.descrDpto||argsSelDpto.descrDpto==="Seleccionar...")&&selecc ?
        <select style={styles.input} className="ui simple selection dropdown fluid" name="ciudad" id="miLista1C" onChange={()=>handleZonaCiudad()}>
          <option value="">Seleccionar...</option>
          {detalleCi}
        </select>
      :
        <div>
          {detalleCi}
        </div>
      }
    </div>
  )
};
//Fin dropdown CIUDADES
//dropdown ZONAS => solo zonas de la ciudad seleccionada
const DetalleSelZo = props => {
  return (
      <option>{props.elemento.nombreZona}</option>
  )
};

const ListaZo = ({styles, argsSelDpto}) => {
  let lisZona = []
  lisZona.push(argsSelDpto)
  const detDetalleZo = lisZona.map((elemento, i) => <DetalleSelZo elemento={elemento} key={i} />);
    return(
        <div>
            <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista2">
              {detDetalleZo}
            </select>
        </div>
    )
};
//Fin dropdown ZONAS
//dropdown BARRIOS => solo barrios de la zona seleccionada
const DetDetalleSelBa = props => {
  return(
      <option dato1={props.elemento.barrio.codigoTipoDocT + "/" + props.elemento.codigoZona}
              dato2={props.elemento.barrio.numeroDocumT + "/" + props.elemento.nombreZona}
              dato3={props.elemento.barrio.descrRecursoT} dato4={props.elemento.barrio.codigoTipoDocR}
              dato5={props.elemento.barrio.numeroDocumR} dato6={props.elemento.barrio.descrRecursoR}
              value={props.elemento.barrio.codigoBarrio}>{props.elemento.barrio.nombreBarrio}</option>
  )
}

const DetalleSelBa = ({styles, elemento, handleBarrioSel}) => {
  var detDetalleBa = []
  var niv5Det = []
  elemento.forEach((elemento1, i) => {
      niv5Det.push(elemento1)
  })
  // niv5Det.push(elemento)
  // console.log(niv5Det)
  detDetalleBa = niv5Det.map((elemento, i) => <DetDetalleSelBa styles={styles} elemento={elemento} key={i} />);
  return (
      <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista3" onChange={()=>handleBarrioSel()}>
          <option value="">Seleccionar...</option>
          {detDetalleBa}
      </select>
  )
};

const ListaBa = ({styles, handleBarrioSel, list, argsSelDpto}) => {
  var detalleBa = []
  list.forEach((elemento, _id) => {
    if(argsSelDpto.codigoDpto && elemento.ciudades.length>0 && elemento.codigoDpto===argsSelDpto.codigoDpto){
      elemento.ciudades.forEach((elemento1, i) => {
        if(argsSelDpto.codigoCiudad && elemento1.codigoCiudad===argsSelDpto.codigoCiudad){
          if(argsSelDpto.codigoDpto && elemento1.zonas.length>0 && elemento.codigoDpto===argsSelDpto.codigoDpto){
            let lisBarr = []
            elemento1.zonas.forEach((elemento2, ii) => {
              elemento2.barrios.forEach((elemento3, ii) => {
                lisBarr.push({barrio: elemento3, codigoZona: elemento2.codigoZona,
                              nombreZona: elemento2.nombreZona})
              })
            })
            lisBarr = _.orderBy(lisBarr, ['barrio.nombreBarrio'])

            let niv4Det = []
            niv4Det.push(lisBarr)
            detalleBa = niv4Det.map((elemento, i) => <DetalleSelBa styles={styles} elemento={elemento} key={i} handleBarrioSel={handleBarrioSel}/>);
          }
        }
      })
    }
  })
  return(
    <div>
      {!argsSelDpto.descrDpto||!argsSelDpto.nombreCiudad||
        argsSelDpto.descrDpto==="Seleccionar..."||argsSelDpto.nombreCiudad==="Seleccionar..." ?
          <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista3B" onChange={()=>handleBarrioSel()}>
            <option value="">Seleccionar...</option>
            {detalleBa}
          </select>
      :
        <div>
          {detalleBa}
        </div>
      }
    </div>
  )
};
//Fin dropdown BARRIOS

  const ListaDirAct = ({linea1, linea2, linea3, linea4}) => {
    return(
      <tbody className=''>
        <tr className=''>
          <td className=''>{linea1}</td>
        </tr>
        <tr className=''>
          <td className=''>{linea2}</td>
        </tr>
        <tr className=''>
          <td className=''>{linea3}</td>
        </tr>
        <tr className=''>
          <td className=''>{linea4}</td>
        </tr>
      </tbody>
    )
  };

const DetalleNivel = props => {
  return (
    <option>{props.elemento.descrCategOST}</option>
  )
};

const ListaCateg = ({handleLista, list}) => {
  const Nivel2Detalle = list.map((elemento, _id) => <DetalleNivel elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrCategOST" id="miListaCateg" onChange={handleLista}>
        <option value="">Seleccionar...</option>
        {Nivel2Detalle}
      </select>
    </div>
  )
};

const DetalleNivelTipo = props => {
  return (
    <option dato1={props.elemento.codigoTipoOS} dato2={props.elemento.descrTipoOS} value={props.elemento._id}>{props.elemento.codigoTipoOS} ={">"} {props.elemento.descrTipoOS}</option>
  )
};

const ListaTipo = ({styles, handleLista, list}) => {
    let nuevoList = []
    nuevoList = list.filter(elemento => elemento.paraCliNuevo==='SI'&&elemento.estadoCrearOS==='NUEVO');
    const NivelDetalleTipo = nuevoList.map((elemento, _id) => <DetalleNivelTipo elemento={elemento} key={elemento._id} />);
    return(
        <div>
            <select style={styles.input} className="ui simple selection dropdown fluid" name="tipoos" id="miListaOS" onChange={handleLista}>
                <option style={styles.input} value="">Seleccionar...</option>
                {NivelDetalleTipo}
            </select>
        </div>
    )
};

// const DetalleNivelCF = props => {
//   return (
//     <option style={props.styles.input} value={props.elemento._id}>{props.elemento.cicloFact}</option>
//   )
// };

// const ListaCF = ({styles, handleLista, list}) => {
//   const NivelDetalleES = list.map((elemento, _id) => <DetalleNivelCF styles={styles} elemento={elemento} key={elemento._id} />);
//   return(
//     <div>
//       <select style={styles.input} className="ui simple selection dropdown fluid" name="cicloFact" id="miListaCF" onChange={handleLista}>
//         <option style={styles.input} value="">Seleccionar...</option>
//         {NivelDetalleES}
//       </select>
//     </div>
//   )
// };

const DetalleNivelES = props => {
  return (
    <option style={props.styles.input} value={props.elemento._id}>{props.elemento.descrEstrato}</option>
  )
};

const ListaES = ({styles, handleLista, list}) => {
  const NivelDetalleES = list.map((elemento, _id) => <DetalleNivelES styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrEstrato" id="miListaEstr" onChange={handleLista}>
        <option style={styles.input} value="">Seleccionar...</option>
        {NivelDetalleES}
      </select>
    </div>
  )
};

const DetalleNivelSeg = props => {
  return (
    <option style={props.styles.input} value={props.elemento.codigoSegmento}>{props.elemento.descrSegmento}</option>
  )
};

const ListaSeg = ({styles, handleLista, list}) => {
  const NivelDetalleES = list.map((elemento, _id) => <DetalleNivelSeg styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrSegmento" id="miListaSeg" onChange={handleLista}>
        <option style={styles.input} value="">Seleccionar...</option>
        {NivelDetalleES}
      </select>
    </div>
  )
};

const DetalleNivelGA = props => {
  return (
    <option dato1={props.elemento.codigoGrupoAfin} dato2={props.elemento.descrGrupoAfin} value={props.elemento._id} style={props.styles.input}>{props.elemento.codigoGrupoAfin} ={">"} {props.elemento.descrGrupoAfin}</option>
  )
};

const ListaGA = ({styles, handleLista, list}) => {
  const NivelDetalleGA = list.map((elemento, _id) => <DetalleNivelGA styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="grupoaf" id="miListaGA" onChange={handleLista}>
        <option style={styles.input} value="">Seleccionar...</option>
        {NivelDetalleGA}
      </select>
    </div>
  )
};

const DetalleNivelTC = props => {
  return (
    <option dato1={props.elemento.codigoTipoCliente} dato2={props.elemento.descrTipoCliente} value={props.elemento.codigoTipoCliente} style={props.styles.input}>{props.elemento.codigoTipoCliente} ={">"} {props.elemento.descrTipoCliente}</option>
  )
};

const ListaTC = ({styles, handleLista, list}) => {
  const NivelDetalleTC = list.map((elemento, _id) => <DetalleNivelTC styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="tipocl" id="miListaTC" onChange={handleLista}>
        <option style={styles.input} value="">Seleccionar...</option>
        {NivelDetalleTC}
      </select>
    </div>
  )
};

const DetalleNivelTD = props => {
  return (
    <option dato1={props.elemento.codigoTipoDoc} dato2={props.elemento.descrTipoDoc} value={props.elemento._id} style={props.styles.input}>{props.elemento.codigoTipoDoc} ={">"} {props.elemento.descrTipoDoc}</option>
  )
};

const ListaTD = ({styles, handleLista, list}) => {
  const NivelDetalleTD = list.map((elemento, _id) => <DetalleNivelTD styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="tipodoc" id="miListaTD" onChange={handleLista}>
        <option style={styles.input} value="">Seleccionar...</option>
        {NivelDetalleTD}
      </select>
    </div>
  )
};

//Lista de TARIFAS
const DetalleSelTar = props => {
  return (
    <option dato1={props.elemento._id} value={props.elemento.codigoTarifa}>{props.elemento.codigoTarifa} ={">"} {props.elemento.descrTarifa}</option>
  )
};

const ListaTar = ({codigoTarifaAct, codigoTarifaNva, styles, handleTarNva, list, listTOS, cicloFact}) => {
  // console.log(list)
  // console.log(codigoTarifaAct)
  const cambTar = listTOS[0].permTarServ.substr(0, 12)
  let detalleTar
  if(cambTar!=="IGUAL TARIFA"){
    detalleTar = list.map((elemento, _id) => <DetalleSelTar elemento={elemento} key={elemento._id} listTOS={listTOS} codigoTarifaAct={codigoTarifaAct}/>);
  }else{
    const listTarTOS = list.filter(item => item.codigoTarifa===codigoTarifaAct);
    detalleTar = listTarTOS.map((elemento, _id) => <DetalleSelTar elemento={elemento} key={elemento._id} listTOS={listTOS} codigoTarifaAct={codigoTarifaAct}/>);
  }
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="tarifa" id="miListaTar" onChange={(ev) => handleTarNva(ev, list, codigoTarifaAct, codigoTarifaNva, listTOS, cicloFact)}>
        <option value="">Seleccionar...</option>
        {detalleTar}
      </select>
    </div>
  )
};
//Fin lista de TARIFAS

const Servicios = ({elemento, handleChangeTar}) => {
  return(
    <tr className=''>
      <td className='collapsing'>
        <div className='ui fitted slider checkbox'>
          <input type='checkbox' name='estadoSelecc' id={elemento.codigoServicio} checked={elemento.estadoSelecc} onChange={(ev)=>handleChangeTar(ev, elemento)}/>
          <label />
        </div>
      </td>
      <td className=''>{elemento.descrClaseServ}</td>
      <td className=''>{elemento.nombreResumido}</td>
      <td className=''>{elemento.descripcionServicio}</td>
    </tr>
  )
};

const ListaServ = ({list, handleChangeTar}) => {
  const nivel1Detalle = list.map((elemento, _id) => <Servicios elemento={elemento} handleChangeTar={handleChangeTar} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

class AddCli2 extends React.Component{
  state = {argsDocum: {numeroDocumV: null, codigoTipoDocV: null, descrRecursoV: "Seleccionar..."},
            valchkbox: 'Masculino', argsSelDpto: {}, listServTar: [], listServ: [],
            codigoTarifaAct: "", codigoTarifaNva: "", cicloFact: null, checkTodo: true, imptosCF: [],
            stListServTarAct: {}, stlistServTarNva: {}}

  handleCiudadDpto = () => {
    this.setState({argsSelDpto: {}})
    var miLista = document.getElementById("miLista");
    const argsSelDpto = this.state.argsSelDpto
    argsSelDpto['descrDpto'] = miLista.options[miLista.selectedIndex].text
    if(miLista.options[miLista.selectedIndex].text!=="Seleccionar..."){
      argsSelDpto['codigoDpto'] = miLista.options[miLista.selectedIndex].attributes[0].value
      argsSelDpto['codigoDptoDANE'] = miLista.options[miLista.selectedIndex].attributes[1].value
      argsSelDpto['_id'] = miLista.options[miLista.selectedIndex].value
    }else{
      argsSelDpto['descrDpto'] = "Seleccionar..."
      argsSelDpto['codigoDpto'] = ""
      argsSelDpto['codigoDptoDANE'] = ""
      argsSelDpto['_id'] = ""
    }
    argsSelDpto['codigoCiudad'] = ""
    argsSelDpto['nombreCiudad'] = "Seleccionar..."
    argsSelDpto['codigoMunicipioDANE'] = ""
    argsSelDpto['codigoPostalDANE'] = ""
    argsSelDpto['codigoCiudadInterno'] = ""
    argsSelDpto['codBarrasRdo'] = ""

    this.setState({argsSelDpto});
  }

  handleZonaCiudad = () => {
    var miLista = document.getElementById("miLista1");
    const argsSelDpto = this.state.argsSelDpto
    argsSelDpto['nombreCiudad'] = miLista.options[miLista.selectedIndex].text
    if(miLista.options[miLista.selectedIndex].text==="Seleccionar..."){
      argsSelDpto['codigoCiudad'] = ""
      argsSelDpto['codigoMunicipioDANE'] = ""
      argsSelDpto['codigoPostalDANE'] = ""
      argsSelDpto['codigoCiudadInterno'] = ""
      argsSelDpto['codBarrasRdo'] = ""
    }else{
      argsSelDpto['codigoCiudad'] = miLista.options[miLista.selectedIndex].value
      argsSelDpto['codigoMunicipioDANE'] = miLista.options[miLista.selectedIndex].attributes[3].value
      argsSelDpto['codigoPostalDANE'] = miLista.options[miLista.selectedIndex].attributes[4].value
      argsSelDpto['codigoCiudadInterno'] = miLista.options[miLista.selectedIndex].attributes[1].value
      argsSelDpto['codBarrasRdo'] = miLista.options[miLista.selectedIndex].attributes[2].value
    }
    this.setState({argsSelDpto});
  }

  handleBarrioSel = () => {
    var miLista = document.getElementById("miLista3");
    const argsSelDpto = this.state.argsSelDpto

    if(miLista.options[miLista.selectedIndex].attributes[1]){
      let dato1 = miLista.options[miLista.selectedIndex].attributes[0].value
      let dato2 = miLista.options[miLista.selectedIndex].attributes[1].value

      let posic1 = dato1.indexOf("/")
      argsSelDpto['codigoTipoDocT'] = dato1.substr(0, posic1)
      argsSelDpto['codigoZona'] = dato1.substr(posic1+1)

      posic1 = dato2.indexOf("/")
      argsSelDpto['numeroDocumT'] = dato2.substr(0, posic1)
      argsSelDpto['nombreZona'] = dato2.substr(posic1+1)
    }
    argsSelDpto['nombreBarrio'] = miLista.options[miLista.selectedIndex].text
    argsSelDpto['codigoBarrio'] = miLista.options[miLista.selectedIndex].value
    argsSelDpto['descrRecursoT'] = miLista.options[miLista.selectedIndex].attributes[2]?miLista.options[miLista.selectedIndex].attributes[2].value:null
    argsSelDpto['codigoTipoDocR'] = miLista.options[miLista.selectedIndex].attributes[3]?miLista.options[miLista.selectedIndex].attributes[3].value:null
    argsSelDpto['numeroDocumR'] = miLista.options[miLista.selectedIndex].attributes[4]?miLista.options[miLista.selectedIndex].attributes[4].value:null
    argsSelDpto['descrRecursoR'] = miLista.options[miLista.selectedIndex].attributes[5]?miLista.options[miLista.selectedIndex].attributes[5].value:null
// console.log(argsSelDpto)
    this.setState({argsSelDpto});
  }

  handleChange = (ev, { value }) => {
    // console.log(this.state.argsDocum)
    if(ev.target.name === "venta"){
      const argsDocum = this.state.argsDocum
      let miLista = document.getElementById("miListaV");
      argsDocum['descrRecursoV'] = miLista.options[miLista.selectedIndex].text
      if(miLista.options[miLista.selectedIndex].text==="Seleccionar..."){
        argsDocum['numeroDocumV'] = null
        argsDocum['codigoTipoDocV'] = null
      }else{
        argsDocum['numeroDocumV'] = ev.target.value
        argsDocum['codigoTipoDocV'] = miLista.options[miLista.selectedIndex].attributes[0].value
      }
      this.setState({argsDocum});
    }else{
      this.setState({ valchkbox: value })
    }
  }

  handleRefreshTar = () => {
    let arrayTabla1=this.state.listServTar
    let arrayTabla2=this.state.listServ
// console.log(arrayTabla1)
// console.log(arrayTabla2)
    // let numS = arrayTabla1.length + 2
    arrayTabla2.forEach((elemento, i) => {
      if(elemento.estadoSelecc===true){
        let numS = new Date().getTime();
        numS = numS + i + 1
        // console.log(numS)
        arrayTabla1.push({codigoTarifa: elemento.codigoTarifa, descrTarifa: elemento.descrTarifa,
          cicloFact: elemento.cicloFact,
          codigoServicio: elemento.codigoServicio, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
          _idSubclaseServ: elemento._idSubclaseServ, codigoSubclaseServ: elemento.codigoSubclaseServ,
          descrSubclaseServ: elemento.descrSubclaseServ, _idClaseServ: elemento._idClaseServ,
          codigoClaseServ: elemento.codigoClaseServ, descrClaseServ: elemento.descrClaseServ,
          velEfecDownstream: elemento.velEfecDownstream, velEfecUpstream: elemento.velEfecUpstream,
          codigoTipoTec: elemento.codigoTipoTec, descrTipoTec: elemento.descrTipoTec,
          colorServicio: elemento.colorServicio,
          rango1NumServValorIni: elemento.rango1NumServValorIni, rango1NumServValorFin: elemento.rango1NumServValorFin,
          rango1Valor: elemento.rango1Valor, rango2NumServValorIni: elemento.rango2NumServValorIni,
          rango2NumServValorFin: elemento.rango2NumServValorFin, rango2Valor: elemento.rango2Valor,
          rango3NumServValorIni: elemento.rango3NumServValorIni, rango3NumServValorFin: elemento.rango3NumServValorFin,
          rango3Valor: elemento.rango3Valor,
          numeroServicios: elemento.numeroServicios!==undefined?elemento.numeroServicios:'1',
          valorServicios: elemento.valorServicios!==undefined?elemento.valorServicios:null,
          valorAntesImptos: elemento.valorAntesImptos!==undefined?elemento.valorAntesImptos:null,
          _id: numS, estadoSelecc: true, imptos: elemento.imptos
        });
          }
    })
// console.log(arrayTabla1)
    let arrayTabla21 = arrayTabla2.filter(item => item.estadoSelecc===true);
    arrayTabla21.forEach((elemento1, _id) => {
      arrayTabla2.forEach((elemento, _id) => {
        if(elemento.estadoSelecc===true && elemento1.codigoServicio===elemento.codigoServicio){
          const indexSearch = arrayTabla2.findIndex( servicio => servicio.codigoServicio === elemento.codigoServicio );
          arrayTabla2.splice(indexSearch, 1);
        }
      })
    })

    arrayTabla1.forEach((elemento, i) => {
      if(elemento.estadoSelecc===false){
        let numS = new Date().getTime();
        numS = numS + i + 1
        arrayTabla2.push({codigoTarifa: elemento.codigoTarifa, descrTarifa: elemento.descrTarifa,
          cicloFact: elemento.cicloFact,
          codigoServicio: elemento.codigoServicio, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
          _idSubclaseServ: elemento._idSubclaseServ, codigoSubclaseServ: elemento.codigoSubclaseServ,
          descrSubclaseServ: elemento.descrSubclaseServ, _idClaseServ: elemento._idClaseServ,
          velEfecDownstream: elemento.velEfecDownstream, velEfecUpstream: elemento.velEfecUpstream,
          codigoTipoTec: elemento.codigoTipoTec, descrTipoTec: elemento.descrTipoTec,
          colorServicio: elemento.colorServicio,
          rango1NumServValorIni: elemento.rango1NumServValorIni, rango1NumServValorFin: elemento.rango1NumServValorFin,
          rango1Valor: elemento.rango1Valor, rango2NumServValorIni: elemento.rango2NumServValorIni,
          rango2NumServValorFin: elemento.rango2NumServValorFin, rango2Valor: elemento.rango2Valor,
          rango3NumServValorIni: elemento.rango3NumServValorIni, rango3NumServValorFin: elemento.rango3NumServValorFin,
          rango3Valor: elemento.rango3Valor,
          codigoClaseServ: elemento.codigoClaseServ, descrClaseServ: elemento.descrClaseServ,
          numeroServicios: elemento.numeroServicios!==undefined?elemento.numeroServicios:'1',
          valorServicios: elemento.valorServicios!==undefined?elemento.valorServicios:null,
          valorAntesImptos: elemento.valorAntesImptos!==undefined?elemento.valorAntesImptos:null,
          _id: numS, estadoSelecc: false, imptos: elemento.imptos});
          }
    })
    // console.log(arrayTabla2)
    arrayTabla21 = arrayTabla1.filter(item => item.estadoSelecc===false);
    arrayTabla21.forEach((elemento1, _id) => {
      arrayTabla1.forEach((elemento, _id) => {
        if(elemento.estadoSelecc===false && elemento1.codigoServicio===elemento.codigoServicio){
          const indexSearch = arrayTabla1.findIndex( servicio => servicio.codigoServicio === elemento.codigoServicio );
          arrayTabla1.splice(indexSearch, 1);
        }
      })
    })
// console.log(arrayTabla1)
// console.log(arrayTabla2)

    this.ordenarArrayAsc(arrayTabla1, 'descrClaseServ')
    this.ordenarArrayAsc(arrayTabla2, 'descrClaseServ')

    this.setState({listServTar: arrayTabla1})
    this.setState({listServ: arrayTabla2})
  }

  handleTarNva = (ev, list, codigoTarifaAct, codigoTarifaNva, listTOS, cicloFact) => {
    // console.log(codigoTarifaAct)
    // console.log(codigoTarifaNva)
    // console.log(ev.target.value)
    // console.log(this.state.stlistServTarNva)
    // console.log(this.state.stListServTarAct)
    // console.log(list)
    // console.log(cicloFact)
    const listServTar = [];
    let cicloFactAct = false
    let elemento2 = []
    // console.log(listTOS[0])
    if(listTOS[0].permTarServ!=="IGUAL TARIFA - QUITAR TODOS LOS SERVICIOS"){
      if(codigoTarifaNva&&codigoTarifaNva===ev.target.value){
        // console.log(this.state.stlistServTarNva)
        elemento2.push(this.state.stlistServTarNva)
      }else{
        if(codigoTarifaAct&&codigoTarifaAct===ev.target.value){
          // console.log(this.state.stListServTarAct)
          cicloFactAct = true
          elemento2.push(this.state.stListServTarAct)
        }else{
          elemento2 = list.filter(elemento => elemento.codigoTarifa===ev.target.value)
          // console.log(elemento2)
        }
      }
    }
    // console.log(elemento2)
    const numST = elemento2.length + 1
    elemento2.forEach((elemento3, ii) => {
      elemento3.servicios.forEach((elemento, i) => {
        if(elemento.codigoServicio){
          // console.log(elemento)
          let valorServicios = 0
          let valorAntesImptos = 0
          let imptosCF = []
          if(elemento.rango1Valor){
            valorServicios = Number(elemento.rango1Valor)
            // if(valorServicios!==null&&valorServicios!==''){
            //   valorServicios = 0
            // }
            let valorI = 0
            elemento.imptos.forEach((elemento1, _id) => {
              valorI += Math.round(valorServicios * (elemento1.porcImpto / 100))
              imptosCF.push({codigoServicio: elemento.codigoServicio, _id: elemento1._id, codigoImpto: elemento1.codigoImpto,
                descrImpto: elemento1.descrImpto, porcImpto: elemento1.porcImpto,
                valorImpto: Math.round(valorServicios * (elemento1.porcImpto / 100))})        
            })
            valorServicios = (Math.round((valorServicios + valorI) / 10) * 10) - valorI
            valorAntesImptos = valorServicios
            valorServicios += valorI
            // console.log(valorAntesImptos, valorServicios, valorI)
          }else{
            imptosCF = elemento.imptos
          }
          listServTar.push({codigoTarifa: elemento3.codigoTarifa, descrTarifa: elemento3.descrTarifa,
            cicloFact: cicloFactAct?cicloFact:elemento3.cicloFact?elemento3.cicloFact:"",
            codigoServicio: elemento.codigoServicio, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
            _idSubclaseServ: elemento.subclaseserv._id, codigoSubclaseServ: elemento.subclaseserv.codigoSubclaseServ,
            descrSubclaseServ: elemento.subclaseserv.descrSubclaseServ, _idClaseServ: elemento.subclaseserv.claseserv._id,
            codigoClaseServ: elemento.subclaseserv.claseserv.codigoClaseServ, descrClaseServ: elemento.subclaseserv.claseserv.descrClaseServ,
            velEfecDownstream: elemento.velEfecDownstream, velEfecUpstream: elemento.velEfecUpstream,
            codigoTipoTec: elemento.codigoTipoTec, descrTipoTec: elemento.descrTipoTec,
            colorServicio: elemento.colorServicio,
            rango1NumServValorIni: elemento.rango1NumServValorIni, rango1NumServValorFin: elemento.rango1NumServValorFin,
            rango1Valor: elemento.rango1Valor, rango2NumServValorIni: elemento.rango2NumServValorIni,
            rango2NumServValorFin: elemento.rango2NumServValorFin, rango2Valor: elemento.rango2Valor,
            rango3NumServValorIni: elemento.rango3NumServValorIni, rango3NumServValorFin: elemento.rango3NumServValorFin,
            rango3Valor: elemento.rango3Valor,
            numeroServicios: codigoTarifaNva===ev.target.value||codigoTarifaAct===ev.target.value?elemento.numeroServicios:'1',
            valorServicios: codigoTarifaNva===ev.target.value||codigoTarifaAct===ev.target.value?elemento.valorServicios:valorServicios,
            valorAntesImptos: codigoTarifaNva===ev.target.value||codigoTarifaAct===ev.target.value?elemento.valorAntesImptos:valorAntesImptos,
            _id: i + numST, estadoSelecc: true, imptos: imptosCF
          });
        }
      })
    })
    // console.log(listServTar)
    this.ordenarArrayAsc(listServTar, 'descrClaseServ')
    this.setState({listServTar})

    elemento2 = []
    if(listTOS[0].permTarServ==="IGUAL TARIFA - QUITAR UNO O VARIOS SERVICIOS"||
      listTOS[0].permTarServ==="IGUAL TARIFA - QUITAR TODOS LOS SERVICIOS"){
      elemento2.push(this.state.stListServTarAct)
    }else{
      elemento2 = list.filter(elemento => elemento.codigoTarifa===ev.target.value)
    }
    const listServ = [];
    elemento2.forEach((elemento3, ii) => {
      elemento3.servicios.forEach((elemento, i) => {
        let siExiste = false
        listServTar.forEach((elemento1, _id) => {
          if(elemento.codigoServicio===elemento1.codigoServicio){
            siExiste = true
          }
        })
        if(siExiste===false){
          // console.log(elemento)
          let valorServicios = 0
          let valorAntesImptos = 0
          let imptosCF = []
          if(elemento.rango1Valor){
            valorServicios = Number(elemento.rango1Valor)
            // if(valorServicios!==null&&valorServicios!==''){
            //   valorServicios = 0
            // }
            let valorI = 0
            elemento.imptos.forEach((elemento1, _id) => {
              valorI += Math.round(valorServicios * (elemento1.porcImpto / 100))
              imptosCF.push({codigoServicio: elemento.codigoServicio, _id: elemento1._id, codigoImpto: elemento1.codigoImpto,
                descrImpto: elemento1.descrImpto, porcImpto: elemento1.porcImpto,
                valorImpto: Math.round(valorServicios * (elemento1.porcImpto / 100))})        
            })
            valorServicios = (Math.round((valorServicios + valorI) / 10) * 10) - valorI
            valorAntesImptos = valorServicios
            valorServicios += valorI
            // console.log(valorAntesImptos, valorServicios, valorI)
          }else{
            imptosCF = elemento.imptos
          }
          listServ.push({codigoTarifa: elemento3.codigoTarifa, descrTarifa: elemento3.descrTarifa,
            cicloFact: cicloFactAct?cicloFact:elemento3.cicloFact?elemento3.cicloFact:"",
            codigoServicio: elemento.codigoServicio, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
            _idSubclaseServ: elemento.subclaseserv._id, codigoSubclaseServ: elemento.subclaseserv.codigoSubclaseServ,
            descrSubclaseServ: elemento.subclaseserv.descrSubclaseServ, _idClaseServ: elemento.subclaseserv.claseserv._id,
            codigoClaseServ: elemento.subclaseserv.claseserv.codigoClaseServ, descrClaseServ: elemento.subclaseserv.claseserv.descrClaseServ,
            velEfecDownstream: elemento.velEfecDownstream, velEfecUpstream: elemento.velEfecUpstream,
            codigoTipoTec: elemento.codigoTipoTec, descrTipoTec: elemento.descrTipoTec,
            colorServicio: elemento.colorServicio,
            rango1NumServValorIni: elemento.rango1NumServValorIni, rango1NumServValorFin: elemento.rango1NumServValorFin,
            rango1Valor: elemento.rango1Valor, rango2NumServValorIni: elemento.rango2NumServValorIni,
            rango2NumServValorFin: elemento.rango2NumServValorFin, rango2Valor: elemento.rango2Valor,
            rango3NumServValorIni: elemento.rango3NumServValorIni, rango3NumServValorFin: elemento.rango3NumServValorFin,
            rango3Valor: elemento.rango3Valor,
            numeroServicios: codigoTarifaAct===ev.target.value?elemento.numeroServicios:'1',
            valorAntesImptos: codigoTarifaAct===ev.target.value?elemento.valorAntesImptos:valorAntesImptos,
            valorServicios: codigoTarifaAct===ev.target.value?elemento.valorServicios:valorServicios,
            _id: i, estadoSelecc: false, imptos: imptosCF});
        }
      })
    })
    // console.log(listServ)
    this.ordenarArrayAsc(listServ, 'descrClaseServ')
    this.setState({listServ})
  }

  handleChangeTar = (ev, elemento) => {
    // console.log(ev.target.name)
    // console.log(elemento)
    // console.log(this.state.listServTar)
    if(ev.target.name === "estadoSeleccPpal" ||
        ev.target.name === "numeroServicios" ||
        ev.target.name === "valorServicios" ||
        ev.target.name === "estadoSeleccTodo"
      ){
      let listServTar=this.state.listServTar
      if(ev.target.name === "estadoSeleccTodo"){
        let checkTodo = this.state.checkTodo

        listServTar.forEach((elemento1, i) => {
          if(checkTodo===false){
            listServTar[i].estadoSelecc = true
          }else{
            listServTar[i].estadoSelecc = false
          }
        })

        if(checkTodo===false){
          checkTodo = true
        }else{
          checkTodo = false
        }

        this.setState({checkTodo});
      }
      const indexSearch = listServTar.findIndex( servicio => servicio.codigoServicio === ev.target.id );
      if(ev.target.name === "estadoSeleccPpal"){
        if(elemento.estadoSelecc===false){
          listServTar[indexSearch].estadoSelecc = true
        }else{
          listServTar[indexSearch].estadoSelecc = false
        }
      }
      if(ev.target.name === "numeroServicios"){
        listServTar[indexSearch].numeroServicios = ev.target.value
        let valorS = null
        let servFinal = 0
        let imptosCF = []
        if(Number(ev.target.value)>=Number(elemento.rango1NumServValorIni)){
          if(Number(ev.target.value)>Number(elemento.rango1NumServValorFin)){
            valorS = elemento.rango1NumServValorFin * elemento.rango1Valor
          }else{
            valorS = ev.target.value * elemento.rango1Valor
          }
          servFinal = elemento.rango1NumServValorFin
        }
        if(elemento.rango2NumServValorIni!==null&&Number(ev.target.value)>=Number(elemento.rango2NumServValorIni)){
          if(Number(ev.target.value)>Number(elemento.rango2NumServValorFin)){
            valorS += (elemento.rango2NumServValorFin - servFinal) * elemento.rango2Valor
          }else{
            valorS += (ev.target.value - servFinal) * elemento.rango2Valor
          }
          servFinal = elemento.rango2NumServValorFin
        }
        if(elemento.rango3NumServValorIni!==null&&Number(ev.target.value)>=Number(elemento.rango3NumServValorIni)){
          if(Number(ev.target.value)>Number(elemento.rango3NumServValorFin)){
            valorS += (elemento.rango3NumServValorFin - servFinal) * elemento.rango3Valor
          }else{
            valorS += (ev.target.value - servFinal) * elemento.rango3Valor
          }
        }
        if(valorS!==null&&valorS!==''){
          let valorI = 0
          elemento.imptos.forEach((elemento1, _id) => {
            valorI += Math.round(valorS * (elemento1.porcImpto / 100))
            imptosCF.push({codigoServicio: elemento.codigoServicio, _id: elemento1._id, codigoImpto: elemento1.codigoImpto,
              descrImpto: elemento1.descrImpto, porcImpto: elemento1.porcImpto,
              valorImpto: Math.round(valorS * (elemento1.porcImpto / 100))})
          })
          valorS = (Math.round((valorS + valorI) / 10) * 10) - valorI
          listServTar[indexSearch].valorAntesImptos = valorS
          valorS += valorI
          // console.log(listServTar[indexSearch].valorAntesImptos, valorS, valorI)
          this.setState({imptosCF});
        }
        listServTar[indexSearch].valorServicios = valorS
        listServTar[indexSearch].imptos = imptosCF
        // console.log(listServTar)
      }
      // console.log(listServTar)
      this.setState({listServTar});
    }

    if(ev.target.name === "estadoSelecc"){
      let listServ=this.state.listServ
      const indexSearch = listServ.findIndex( servicio => servicio.codigoServicio === ev.target.id );
      if(elemento.estadoSelecc===false){
        listServ[indexSearch].estadoSelecc = true
      }else{
        listServ[indexSearch].estadoSelecc = false
      }
      this.setState({listServ});
    }
  }

  ordenarArrayAsc = (array, campo) => {
    array.sort(function (a, b) {
       return a[campo] > b[campo];
    });
  }
  
  componentDidMount(){
//la primera vez que entra a este componente (addcli2) va a componentDidUpdate, despues ya entra aqui
    if(!this.state.argsSelDpto.codigoDpto){
      if(this.props.allDirmayor.allDirmayor){
        if(this.props.allDirmayor.allDirmayor.length===1||this.props.codigoCiudadUA!=="Todas..."||this.props.codigoDptoUA!=="Todos..."){
          const argsSelDpto = {}
          if(this.props.codigoCiudadUA!=="Todas..."){
            this.props.allDirmayor.allDirmayor.forEach((elemento, _id) => {
              elemento.ciudades.forEach((elemento1, _id) => {
                if(elemento1.codigoCiudad===this.props.codigoCiudadUA){
                  argsSelDpto['codigoDpto'] = elemento.codigoDpto
                  argsSelDpto['descrDpto'] = elemento.descrDpto
                  argsSelDpto['codigoDptoDANE'] = elemento.codigoDptoDANE
                  argsSelDpto['_id'] = elemento._id
  
                  argsSelDpto['nombreCiudad'] = elemento1.nombreCiudad
                  argsSelDpto['codigoCiudad'] = elemento1.codigoCiudad
                  argsSelDpto['codigoMunicipioDANE'] = elemento1.codigoMunicipioDANE
                  argsSelDpto['codigoPostalDANE'] = elemento1.codigoPostalDANE
                  argsSelDpto['codigoCiudadInterno'] = elemento1.codigoCiudadInterno
                  argsSelDpto['codBarrasRdo'] = elemento1.codBarrasRdo
                }
              })
            })
          }else{
            let indexSearch = 0
            if(this.props.allDirmayor.allDirmayor.length>1){
              if(this.props.codigoDptoUA!=="Todos..."){
                indexSearch = this.props.allDirmayor.allDirmayor.findIndex(elemento => elemento.codigoDpto===this.props.codigoDptoUA);
              }
            }
            if(indexSearch!==-1){
              argsSelDpto['codigoDpto'] = this.props.allDirmayor.allDirmayor[indexSearch].codigoDpto
              argsSelDpto['descrDpto'] = this.props.allDirmayor.allDirmayor[indexSearch].descrDpto
              argsSelDpto['codigoDptoDANE'] = this.props.allDirmayor.allDirmayor[indexSearch].codigoDptoDANE
              argsSelDpto['_id'] = this.props.allDirmayor.allDirmayor[indexSearch]._id
              if(this.props.allDirmayor.allDirmayor[indexSearch].ciudades.length===1){
                argsSelDpto['nombreCiudad'] = this.props.allDirmayor.allDirmayor[indexSearch].ciudades[0].nombreCiudad
                argsSelDpto['codigoCiudad'] = this.props.allDirmayor.allDirmayor[indexSearch].ciudades[0].codigoCiudad
                argsSelDpto['codigoMunicipioDANE'] = this.props.allDirmayor.allDirmayor[indexSearch].ciudades[0].codigoMunicipioDANE
                argsSelDpto['codigoPostalDANE'] = this.props.allDirmayor.allDirmayor[indexSearch].ciudades[0].codigoPostalDANE
                argsSelDpto['codigoCiudadInterno'] = this.props.allDirmayor.allDirmayor[indexSearch].ciudades[0].codigoCiudadInterno
                argsSelDpto['codBarrasRdo'] = this.props.allDirmayor.allDirmayor[indexSearch].ciudades[0].codBarrasRdo
              }else{
                argsSelDpto['nombreCiudad'] = "Seleccionar..."
                argsSelDpto['codigoCiudad'] = ""
                argsSelDpto['codigoMunicipioDANE'] = ""
                argsSelDpto['codigoPostalDANE'] = ""
                argsSelDpto['codigoCiudadInterno'] = ""
                argsSelDpto['codBarrasRdo'] = ""        
              }
            }
          }
          this.setState({argsSelDpto});
        }
      }
    }
  }

  componentDidUpdate(prevState){
    // console.log("22", this.state.argsSelDpto.descrDpto, this.state.argsSelDpto.codigoDpto)
    let miLista = document.getElementById("miLista");
    if(miLista){
      if(this.state.argsSelDpto.descrDpto&&
          this.state.argsSelDpto.descrDpto!==miLista.options[miLista.selectedIndex].text&&
          miLista.options[miLista.selectedIndex].text==="Seleccionar..."&&this.props.codigoDptoUA==="Todos..."){
        let argsSelDpto = {}
        argsSelDpto['codigoDpto'] = ""
        argsSelDpto['descrDpto'] = "Seleccionar..."
        argsSelDpto['codigoDptoDANE'] = ""
        argsSelDpto['_id'] = ""

        argsSelDpto['nombreCiudad'] = "Seleccionar..."
        argsSelDpto['codigoCiudad'] = ""
        argsSelDpto['codigoMunicipioDANE'] = ""
        argsSelDpto['codigoPostalDANE'] = ""
        argsSelDpto['codigoCiudadInterno'] = ""
        argsSelDpto['codBarrasRdo'] = ""
        this.setState({argsSelDpto})
      }else{
        if(this.props.allDirmayor.allDirmayor&&this.state.argsSelDpto.codigoDpto&&!this.state.argsSelDpto.codigoCiudad){
          this.props.allDirmayor.allDirmayor.forEach((elemento, _id) => {
            if(elemento.codigoDpto===this.state.argsSelDpto.codigoDpto){
              elemento.ciudades.forEach((elemento1, _id) => {
                if(elemento.ciudades.length===1){
                  const argsSelDpto = this.state.argsSelDpto
                  argsSelDpto['nombreCiudad'] = elemento1.nombreCiudad
                  argsSelDpto['codigoCiudad'] = elemento1.codigoCiudad
                  argsSelDpto['codigoMunicipioDANE'] = elemento1.codigoMunicipioDANE
                  argsSelDpto['codigoPostalDANE'] = elemento1.codigoPostalDANE
                  argsSelDpto['codigoCiudadInterno'] = elemento1.codigoCiudadInterno
                  argsSelDpto['codBarrasRdo'] = elemento1.codBarrasRdo
                  this.setState({argsSelDpto});
                }
              })
            }
          })
        }  
      }
      // console.log(this.state.argsSelDpto.descrDpto, miLista.options[miLista.selectedIndex].text)
    }

    miLista = document.getElementById("miLista1");
    if(miLista){
      if(this.state.argsSelDpto.nombreCiudad&&
          this.state.argsSelDpto.nombreCiudad!==miLista.options[miLista.selectedIndex].text&&
          miLista.options[miLista.selectedIndex].text==="Seleccionar..."&&this.props.codigoCiudadUA==="Todas..."){
        let argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreCiudad'] = "Seleccionar..."
        argsSelDpto['codigoCiudad'] = ""
        argsSelDpto['codigoMunicipioDANE'] = ""
        argsSelDpto['codigoPostalDANE'] = ""
        argsSelDpto['codigoCiudadInterno'] = ""
        argsSelDpto['codBarrasRdo'] = ""
        this.setState({argsSelDpto})
      }
      // console.log(this.state.argsSelDpto.nombreCiudad, miLista.options[miLista.selectedIndex].text)
    }

    if(this.props.args.descrTipoOS&&this.props.args.descrTipoOS==="Seleccionar..."&&
        this.state.argsDocum.descrRecursoV!=="Seleccionar..."){
      this.setState({argsDocum: {numeroDocumV: null, codigoTipoDocV: null, descrRecursoV: "Seleccionar..."}});
    }
    if(!this.state.argsSelDpto.codigoDpto||
        (this.props.args.descrTipoOS&&this.props.args.descrTipoOS==="Seleccionar..."&&
            this.state.argsSelDpto.nombreBarrio)){
              // console.log(this.state.argsSelDpto.codigoDpto, this.props.args.descrTipoOS, this.state.argsSelDpto.nombreBarrio)
      if(this.props.allDirmayor.allDirmayor){
        if(this.props.allDirmayor.allDirmayor.length===1||this.props.codigoCiudadUA!=="Todas..."||
            this.props.codigoDptoUA!=="Todos..."){
              // console.log(this.props.allDirmayor.allDirmayor.length, this.props.codigoCiudadUA, this.props.codigoDptoUA)
          let argsSelDpto = this.state.argsSelDpto
          if(this.props.codigoCiudadUA!=="Todas..."){
            argsSelDpto = {}
            this.props.allDirmayor.allDirmayor.forEach((elemento, _id) => {
              elemento.ciudades.forEach((elemento1, _id) => {
                if(elemento1.codigoCiudad===this.props.codigoCiudadUA){
                  argsSelDpto['codigoDpto'] = elemento.codigoDpto
                  argsSelDpto['descrDpto'] = elemento.descrDpto
                  argsSelDpto['codigoDptoDANE'] = elemento.codigoDptoDANE
                  argsSelDpto['_id'] = elemento._id
  
                  argsSelDpto['nombreCiudad'] = elemento1.nombreCiudad
                  argsSelDpto['codigoCiudad'] = elemento1.codigoCiudad
                  argsSelDpto['codigoMunicipioDANE'] = elemento1.codigoMunicipioDANE
                  argsSelDpto['codigoPostalDANE'] = elemento1.codigoPostalDANE
                  argsSelDpto['codigoCiudadInterno'] = elemento1.codigoCiudadInterno
                  argsSelDpto['codBarrasRdo'] = elemento1.codBarrasRdo

                  this.setState({argsSelDpto});
                }
              })
            })
          }else{
            // console.log("11", this.props.codigoDptoUA)
            let indexSearch = 0
            if(this.props.allDirmayor.allDirmayor.length>1){
              if(this.props.codigoDptoUA!=="Todos..."){
                indexSearch = this.props.allDirmayor.allDirmayor.findIndex(elemento => elemento.codigoDpto===this.props.codigoDptoUA);
              }
            }
            if(indexSearch!==-1){
              argsSelDpto = {}
              argsSelDpto['codigoDpto'] = this.props.allDirmayor.allDirmayor[indexSearch].codigoDpto
              argsSelDpto['descrDpto'] = this.props.allDirmayor.allDirmayor[indexSearch].descrDpto
              argsSelDpto['codigoDptoDANE'] = this.props.allDirmayor.allDirmayor[indexSearch].codigoDptoDANE
              argsSelDpto['_id'] = this.props.allDirmayor.allDirmayor[indexSearch]._id
              if(this.props.allDirmayor.allDirmayor[indexSearch].ciudades.length===1){
                argsSelDpto['nombreCiudad'] = this.props.allDirmayor.allDirmayor[indexSearch].ciudades[0].nombreCiudad
                argsSelDpto['codigoCiudad'] = this.props.allDirmayor.allDirmayor[indexSearch].ciudades[0].codigoCiudad
                argsSelDpto['codigoMunicipioDANE'] = this.props.allDirmayor.allDirmayor[indexSearch].ciudades[0].codigoMunicipioDANE
                argsSelDpto['codigoPostalDANE'] = this.props.allDirmayor.allDirmayor[indexSearch].ciudades[0].codigoPostalDANE
                argsSelDpto['codigoCiudadInterno'] = this.props.allDirmayor.allDirmayor[indexSearch].ciudades[0].codigoCiudadInterno
                argsSelDpto['codBarrasRdo'] = this.props.allDirmayor.allDirmayor[indexSearch].ciudades[0].codBarrasRdo
              }else{
                argsSelDpto['nombreCiudad'] = "Seleccionar..."
                argsSelDpto['codigoCiudad'] = ""
                argsSelDpto['codigoMunicipioDANE'] = ""
                argsSelDpto['codigoPostalDANE'] = ""
                argsSelDpto['codigoCiudadInterno'] = ""
                argsSelDpto['codBarrasRdo'] = ""        
              }
              this.setState({argsSelDpto});
            }
          }
        }
      }
    }
  }

  render(){
    const {argsDocum, valchkbox, argsSelDpto, listServTar, listServ, codigoTarifaAct, codigoTarifaNva,
          cicloFact, checkTodo, imptosCF} = this.state;
    // console.log(this.props.comoAsigCicloFact)
    // console.log(this.props.args)
    // console.log(argsSelDpto)
    // console.log(listServTar)
    // console.log(argsDocum)
    let addOS = false
    if(this.props.args.descrTipoOS&&this.props.args.descrTipoOS!=="Seleccionar..."){
      addOS = true
    }
    let listTipo = []
    let listaCateg = []
    let list1 = []
    let list2 = []
    let list3 = []
    let list4 = []
    let list5 = []
    let list6 = []
    if(this.props.allTiposOS.allTiposOS){listTipo = this.props.allTiposOS.allTiposOS}

    // console.log(this.props.args)
    if(this.props.allCategOST.allCategOST&&this.props.args.descrTipoOS&&this.props.args.descrTipoOS!=="Seleccionar..."){
      listaCateg = this.props.allCategOST.allCategOST.filter(elemento => elemento.descrTipoOS===this.props.args.descrTipoOS)
    }
    // console.log(listaCateg)
    if(this.props.allDirmayor.allDirmayor){
      // list1 = this.props.allDirmayor.allDirmayor
      let listaDir = this.props.allDirmayor.allDirmayor
      if(this.props.codigoDptoUA!=="Todos..."){
        listaDir = listaDir.filter(elemento => elemento.codigoDpto===this.props.codigoDptoUA)
      }
      if(this.props.codigoCiudadUA!=="Todas..."){
        let listaD = []
        listaDir.forEach((elemento, _id) => {
          if(listaD.length===0){
            elemento.ciudades.forEach((elemento1, _id) => {
              if(elemento1.codigoCiudad===this.props.codigoCiudadUA){
                listaD.push(elemento)
              }
            })
          }
        })
        list1 = listaD
        let dpto = document.getElementById("miLista");
        if(dpto){
          dpto.options.selectedIndex = 0
        }
      }else{
        list1 = listaDir
      }
    }
    // console.log(list1)
    if(this.props.allTipoVia.allTipoVia){list2 = this.props.allTipoVia.allTipoVia}
    if(this.props.allTipoUnd.allTipoUnd){list3 = this.props.allTipoUnd.allTipoUnd}
    if(this.props.allTiUndMat.allTiUndMat){list4 = this.props.allTiUndMat.allTiUndMat}
    if(this.props.allUndMat.allUndMat){list5 = this.props.allUndMat.allUndMat}
    if(this.props.allTarifa.allTarifa){
      list6 = this.props.allTarifa.allTarifa
      list6 = list6.filter(elemento => elemento.estadoTarifa===true)
    }

    let linea1DNN = ""
    let linea2DNN = ""
    let linea3DNN = ""
    let linea4DNN = ""

    linea1DNN = `${argsSelDpto.descrTipoVia1?argsSelDpto.descrTipoVia1:""}
      ${argsSelDpto.numeroTipoVia1?argsSelDpto.numeroTipoVia1:""}
      ${argsSelDpto.descrTipoVia2?argsSelDpto.descrTipoVia2:""}
      ${argsSelDpto.numeroTipoVia2?argsSelDpto.numeroTipoVia2:""}
      ${argsSelDpto.numeroTipoVia2F?argsSelDpto.numeroTipoVia2F:""}
      ${argsSelDpto.descrTipoUnd1?argsSelDpto.descrTipoUnd1:""}
      ${argsSelDpto.numeroTipoUnd1?argsSelDpto.numeroTipoUnd1:""}
      ${argsSelDpto.descrTipoUnd2?argsSelDpto.descrTipoUnd2:""}
      ${argsSelDpto.numeroTipoUnd2?argsSelDpto.numeroTipoUnd2:""}`

    linea2DNN = `${argsSelDpto.descrTiUndMat?argsSelDpto.descrTiUndMat:""}
      ${argsSelDpto.descrUndMat?argsSelDpto.descrUndMat:""}`

    linea3DNN = `${argsSelDpto.descrDpto?argsSelDpto.descrDpto:""}
      ${argsSelDpto.nombreCiudad?", " + argsSelDpto.nombreCiudad:""}`
  
    linea4DNN = `${argsSelDpto.nombreZona?", Zona: " + argsSelDpto.nombreZona:""}
      ${argsSelDpto.nombreBarrio?", Barrio: " + argsSelDpto.nombreBarrio:""}`

//Para TARIFAS
    let tipoOS = listTipo.filter(elemento => elemento.descrTipoOS===this.props.args.descrTipoOS)
    
    let fechaHoy = new Date()
    let fechaV = (fechaHoy.getFullYear()+1) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
    if(this.props.args.fechaVence){
      fechaV = this.props.args.fechaVence
    }

    const labelTN1 = "<< SE ASIGNARAN LOS SIGUIENTES SERVICIOS >>"
    const labelTN2 = "<< Servicios NO asignados >>"
// console.log(this.props.args.descrTipoDoc)
// console.log(this.props.contratoSequence)
  return(
    <div>
      <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
        <i className="large user plus yellow icon"></i>
        Cliente nuevo
      </button>
      <div style={this.props.styles.box}>
        <Form onSubmit={(ev)=>this.props.handleSubmit(ev, this.props.args, this.props.comoAsigCicloFact,
                        argsSelDpto, listServTar, tipoOS, fechaV, argsDocum, this.props.modeloFactura, this.props.empresaArchFE, listaCateg)}>
          <div className="ui two column stackable grid">
            <div className="row container">
              <div className="column" style={this.props.styles.boxGrid}>
                {(this.props.args.codigoTipoDoc==="NIT"&&this.props.args.descrTipoDoc!==undefined&&this.props.args.descrTipoDoc!=="Seleccionar...") &&
                  <label style={{
                    ...this.props.styles.label,
                    color: "#82e256", textAlign: "center", fontSize: "24px", display: "block"
                  }}>EMPRESA</label>
                }
                {(this.props.args.codigoTipoDoc!=="NIT"&&this.props.args.descrTipoDoc!==undefined&&this.props.args.descrTipoDoc!=="Seleccionar...") &&
                  <label style={{
                    ...this.props.styles.label,
                    color: "#82e256", textAlign: "center", fontSize: "24px", display: "block"
                  }}>PERSONA</label>
                }
                {this.props.contratoSequence!=="SI" &&
                  <Form.Field>
                    <label style={this.props.styles.label}>Contrato</label>
                    <input style={this.props.styles.input} pattern={"[a-zA-Z0-9]+"} autoComplete="off" name="contrato" id="contrato" onChange={this.props.handleChange} placeholder='Contrato' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'contrato'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                }

                <Form.Field>
                  <label style={this.props.styles.label}>Nombre</label>
                  <input style={this.props.styles.input} autoComplete="off" name="nombreCliente" id="nombreCliente" onChange={this.props.handleChange} placeholder='Nombre' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'nombreCliente'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <label style={this.props.styles.label}>Apellido(s)</label>
                  <input style={this.props.styles.input} autoComplete="off" name="apellidoCliente" id="apellidoCliente" onChange={this.props.handleChange} placeholder='Apellido(s)' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'apellidoCliente'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <div className="ui two column stackable grid">
                    <div className="column" style={{width: '50%'}}>
                      <label style={this.props.styles.label}>Estrato</label>
                      <ListaES list={this.props.list3} styles={this.props.styles} handleLista={this.props.handleListaEstr} />
                    </div>
                    {this.props.listSeg.length>1 &&
                      <div className="column" style={{width: '50%'}}>
                        <label style={this.props.styles.label}>Segmento</label>
                        <ListaSeg list={this.props.listSeg} styles={this.props.styles} handleLista={this.props.handleListaSeg} />
                      </div>
                    }

                    {/* {this.props.comoAsigCicloFact==="Asignarlo al crear o modificar clientes" &&
                    <div className="column" style={{width: '50%'}}>
                      <label style={this.props.styles.label}>Ciclo de facturación</label>
                      <ListaCF list={this.props.list8} styles={this.props.styles} handleLista={this.props.handleListaCF} />
                    </div>
                    } */}
                  </div>
                </Form.Field>
                <Form.Field>
                  <label style={this.props.styles.label}>Sexo</label>
                  <Form.Checkbox className="ui radio checkbox" style={{padding: '0em 2em 0em 0em'}}
                    radio label='Masculino' name='sexoCliente' value='Masculino'
                    checked={valchkbox === 'Masculino'} onClick={this.handleChange} onChange={this.props.handleChange}
                  />
                  <Form.Checkbox className="ui radio checkbox" style={{padding: '0em 2em 0em 0em'}}
                    radio label='Femenino' name='sexoCliente' value='Femenino'
                    checked={valchkbox === 'Femenino'} onClick={this.handleChange} onChange={this.props.handleChange}
                  />
                </Form.Field>

                <Form.Field>
                  <label style={this.props.styles.label}>Documento de identidad</label>
                  <div className="ui two column stackable grid">
                    <div className="column" style={{width: '60%'}}>
                      <ListaTD list={this.props.list} styles={this.props.styles} handleLista={this.props.handleListaTD} />
                    </div>
                    <div className="column" style={{width: '40%'}}>
                      <input style={this.props.styles.input} pattern={
                          this.props.args.codigoTipoDoc === "NIT"
                            ? "[0-9]{5,10}-[0-9]"
                            : "[0-9]{5,10}[0-9\\-]{0,1}[0-9]{0,1}"
                        } autoComplete="off" name="numeroDoc" id="numeroDoc" onChange={this.props.handleChange} placeholder='Número del documento' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'numeroDoc'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                    </div>
                  </div>
                </Form.Field>

                <Form.Field>
                  <label style={this.props.styles.label}>Tipo de cliente</label>
                  <ListaTC list={this.props.list1} styles={this.props.styles} handleLista={this.props.handleListaTC} />
                </Form.Field>
                <Form.Field>
                  <label style={this.props.styles.label}>Grupo de afinidad</label>
                  <ListaGA list={this.props.list2} styles={this.props.styles} handleLista={this.props.handleListaGA} />
                </Form.Field>
              </div>
              <div className="column" style={this.props.styles.boxGrid}>
                <Form.Field>
                  <label style={this.props.styles.label}>Teléfonos de contacto</label>
                  <input style={this.props.styles.input} pattern={"[0-9]{7,10}"} autoComplete="off" name="telefono1" id="telefono1" onChange={this.props.handleChange} placeholder='Teléfono 1' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'telefono1'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  <input style={this.props.styles.input} pattern={"[0-9]{7,10}"} autoComplete="off" name="telefono2" id="telefono2" onChange={this.props.handleChange} placeholder='Teléfono 2' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'telefono2'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  <input style={this.props.styles.input} pattern={"[0-9]{7,10}"} autoComplete="off" name="telefono3" id="telefono3" onChange={this.props.handleChange} placeholder='Teléfono 3' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'telefono3'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <label style={this.props.styles.label}>Correo electrónico</label>
                  <input style={this.props.styles.input} pattern={"[a-z0-9._%+\\-]+@[a-z0-9.\\-]+\.[a-z]{0,}$"} autoComplete="off" name="eMail" id="eMail" onChange={this.props.handleChange} placeholder='Correo electrónico' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'eMail'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>

                <Form.Field>
                  <label style={this.props.styles.label}>Fecha de cumpleaños</label>
                  <input style={this.props.styles.input} type='date' name="fechaCumple" id="fechaCumple" value={argsDocum.fechaCumple} onChange={this.props.handleChange}/>
                </Form.Field>

                <Form.Field>
                  <label style={this.props.styles.label}>Referencia 1 ={">"} Nombre y teléfono</label>
                  <input style={this.props.styles.input} autoComplete="off" name="referencia1" id="referencia1" onChange={this.props.handleChange} placeholder='Nombre referencia 1' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'referencia1'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  <input style={this.props.styles.input} autoComplete="off" name="telefonoRef1" id="telefonoRef1" onChange={this.props.handleChange} placeholder='Teléfono referencia 1' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'telefonoRef1'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <label style={this.props.styles.label}>Referencia 2 ={">"} Nombre y teléfono</label>
                  <input style={this.props.styles.input} autoComplete="off" name="referencia2" id="referencia2" onChange={this.props.handleChange} placeholder='Nombre referencia 2' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'referencia2'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  <input style={this.props.styles.input} autoComplete="off" name="telefonoRef2" id="telefonoRef2" onChange={this.props.handleChange} placeholder='Teléfono referencia 2' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'telefonoRef2'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>

                <Form.Field>
                  {/* <label style={this.props.styles.label}>Departamento</label> */}
                  <label style={this.props.styles.label}>Ciudad</label>
                  <ListaDe list={list1} styles={this.props.styles} handleCiudadDpto={this.handleCiudadDpto}
                    codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}/>
                {/* </Form.Field>
                <Form.Field>
                  <label style={this.props.styles.label}>Ciudad</label> */}
                  <ListaCi list={list1} styles={this.props.styles} handleZonaCiudad={this.handleZonaCiudad}
                    argsSelDpto={argsSelDpto} codigoCiudadUA={this.props.codigoCiudadUA}/>
                </Form.Field>
                {/* 
                <Form.Field>
                  <label style={this.props.styles.label}>Observaciones</label>
                  <input style={this.props.styles.input} autoComplete="off" name="observaciones" id="observaciones" onChange={this.props.handleChange} placeholder='Observaciones' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'apellidoCliente'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field> */}
                {this.props.empresaArchFE==="conectic" &&
                  <Form.Field>
                    <label style={this.props.styles.label}>Información adicional</label>
                    <ListaInfAdic styles={this.props.styles} handleListaInfAdic={this.props.handleListaInfAdic} />
                  </Form.Field>
                }
                {(this.props.modeloFactura!=="1"&&this.props.empresaArchFE!=="conectic") &&
                  <Form.Field>
                    <label style={this.props.styles.label}>Información adicional</label>
                    <input style={this.props.styles.input} autoComplete="off" name="infAdic1" id="infAdic1" onChange={this.props.handleChange} placeholder='Información adicional' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'infAdic1'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
              }
              </div>
            </div>
          </div>
          
          <Form.Field>
            <label style={this.props.styles.label}>Observaciones</label>
            <input style={this.props.styles.input} autoComplete="off" name="observaciones" id="observaciones" onChange={this.props.handleChange} placeholder='Observaciones' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'apellidoCliente'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
          </Form.Field>
          <hr></hr>


  {/* PARA CREAR OS */}
          {this.props.a01010105!==-1 &&
            <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
              {/* <Form.Field>
                <label style={this.props.styles.elemLis_2}>Orden de Servicio</label>
                <ListaTipo list={listTipo} styles={this.props.styles} handleLista={this.props.handlelista5}/>
              </Form.Field> */}

              <Form.Field>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={this.props.styles.boxGrid}>
                      <label style={this.props.styles.elemLis_2}>Tipo</label>
                      <ListaTipo list={listTipo} styles={this.props.styles} handleLista={this.props.handlelista5}/>
                    </div>

                    {listaCateg.length>0 &&
                      <div className="column" style={this.props.styles.boxGrid}>
                        <label style={this.props.styles.elemLis_2}>Categoría</label>
                        <ListaCateg list={listaCateg} styles={this.props.styles} handleLista={this.props.handleLista1}/>
                      </div>
                    }
                  </div>
                </div>
              </Form.Field>



              {addOS &&
                <div>
                  <Form.Field>
                    <label style={this.props.styles.elemLis_2}>Observaciones</label>
                    <input style={this.props.styles.input} autoComplete="off" name="observacAB" id="observacAB" onChange={this.props.handleChange} placeholder='Observaciones' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'observacAB'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.elemLis_2}>Vendedor</label>
                    <ListaV styles={this.props.styles} list={this.props.list12} handleChange={this.handleChange}/>
                  </Form.Field>
  {/* DIRECCION */}
                  <Divider inverted />
                  <label style={this.props.styles.elemLis_2}>Dirección</label>
                  <div className='ui blue inverted raised segment'>
                    <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableInf}>
                      <ListaDirAct linea1={linea1DNN} linea2={linea2DNN} linea3={linea3DNN} linea4={linea4DNN}/>
                    </table>
                    <div className="ui two column stackable grid">
                      <div className="row container">
                        <div className="column" style={this.props.styles.boxGrid}>
                          <Form.Field>
                            <label style={this.props.styles.label}>Vía principal</label>
                            <Lista seleccLista="descrTipoVia1" list={list2} styles={this.props.styles} handleLista4={this.props.handleLista4}/>
                            <input style={this.props.styles.input} autoComplete="off" name="numeroTipoVia1" id="numeroTipoVia1" onChange={this.props.handleChange} placeholder='Número'/>
                          </Form.Field>
                          <Form.Field>
                            <label style={this.props.styles.label}>Vía secundaria</label>
                            <Lista seleccLista="descrTipoVia2" list={list2} styles={this.props.styles} handleLista4={this.props.handleLista4}/>
                            <input style={this.props.styles.input} autoComplete="off" name="numeroTipoVia2" id="numeroTipoVia2" onChange={this.props.handleChange} placeholder='Número'/>
                            <input style={this.props.styles.input} autoComplete="off" name="numeroTipoVia2F" id="numeroTipoVia2F" onChange={this.props.handleChange} placeholder='Número'/>
                          </Form.Field>
                          <Form.Field>
                            <label style={this.props.styles.label}>Tipo de unidad 1</label>
                            <Lista seleccLista="descrTipoUnd1" list={list3} styles={this.props.styles} handleLista4={this.props.handleLista4}/>
                            <input style={this.props.styles.input} autoComplete="off" name="numeroTipoUnd1" id="numeroTipoUnd1" onChange={this.props.handleChange} placeholder='Número'/>
                          </Form.Field>
                          {/* <Form.Field>
                            <label style={this.props.styles.label}>Tipo de unidad 2</label>
                            <Lista seleccLista="descrTipoUnd2" list={list3} styles={this.props.styles} handleLista4={this.props.handleLista4}/>
                            <input style={this.props.styles.input} autoComplete="off" name="numeroTipoUnd2" id="numeroTipoUnd2" onChange={this.props.handleChange} placeholder='Número'/>
                          </Form.Field> */}
                        </div>
                        <div className="column" style={this.props.styles.boxGrid}>
                          <Form.Field>
                            <label style={this.props.styles.label}>Tipo de unidad 2</label>
                            <Lista seleccLista="descrTipoUnd2" list={list3} styles={this.props.styles} handleLista4={this.props.handleLista4}/>
                            <input style={this.props.styles.input} autoComplete="off" name="numeroTipoUnd2" id="numeroTipoUnd2" onChange={this.props.handleChange} placeholder='Número'/>
                          </Form.Field>
                          <Form.Field>
                            <label style={this.props.styles.label}>Unidad matriz</label>
                            <Lista seleccLista="descrTiUndMat" list={list4} styles={this.props.styles} handleLista4={this.props.handleLista4}/>
                            <Lista seleccLista="descrUndMat" list={list5} styles={this.props.styles} handleLista4={this.props.handleLista4}/>
                          </Form.Field>
                          {/* <Form.Field>
                            <label style={this.props.styles.label}>Departamento</label>
                            <ListaDe list={list1} styles={this.props.styles} handleCiudadDpto={this.handleCiudadDpto} />
                          </Form.Field>
                          <Form.Field>
                            <label style={this.props.styles.label}>Ciudad</label>
                            <ListaCi list={list1} styles={this.props.styles} handleZonaCiudad={this.handleZonaCiudad} argsSelDpto={argsSelDpto}/>
                          </Form.Field> */}
                          <Form.Field>
                            <label style={this.props.styles.label}>Barrio</label>
                            <ListaBa list={list1} styles={this.props.styles} handleBarrioSel={this.handleBarrioSel} argsSelDpto={argsSelDpto}/>
                          </Form.Field>
                          <Form.Field>
                            <label style={this.props.styles.label}>Zona</label>
                            <ListaZo styles={this.props.styles} argsSelDpto={argsSelDpto}/>
                          </Form.Field>
                        </div>
                      </div>
                    </div>
                  </div>

  {/* TARIFA */}

                  <Divider inverted />
                  <label style={this.props.styles.elemLis_2}>Tarifa</label>
                  <div className='ui blue inverted raised segment'>
                    <a className='ui large label' style={this.props.styles.styTableInf} onClick={this.handleRefreshTar}><i className='redo icon'></i>Refrescar</a>
                    <Form.Field>
                      <ListaTar codigoTarifaAct={codigoTarifaAct} codigoTarifaNva={codigoTarifaNva}
                          list={list6} listTOS={tipoOS} styles={this.props.styles}
                          handleTarNva={this.handleTarNva} cicloFact={cicloFact}/>
                      <label style={this.props.styles.label}>Fecha de vencimiento</label>
                      <input type='date' name="fechaVence" id="fechaVence" value={fechaV} onChange={(ev)=>this.props.handleChange(ev)}/>
                    </Form.Field>
                    <hr></hr>

                    <a style={this.props.styles.elemLis_2}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a>
                    <div className='ui fitted slider checkbox'>
                      <input style={{paddingLeft: '0.7em', paddingRight: '0.7em'}} type='checkbox' name='estadoSeleccTodo' checked={checkTodo} onChange={(ev)=>this.handleChangeTar(ev)}/>
                      <label />
                    </div>
                    <a style={this.props.styles.elemLis_2}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{labelTN1}</a>

                    <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                      <thead className=''>
                        <tr className=''>
                          <th className=''></th>
                          <th className=''>Clase</th>
                          <th className=''>Servicio</th>
                          <th className=''>Descripción servicio</th>
                          <th className='center aligned'># serv</th>
                          <th className='center aligned'>Valor serv</th>
                        </tr>
                      </thead>
                      <ListaServTar styles={this.props.styles} list={listServTar} permAct='cambiar' handleChangeTar={this.handleChangeTar} imptosCF={imptosCF}/>
                    </table>          

                    <Divider inverted />
                    <hr></hr>
                    <a style={this.props.styles.elemLis_2}>{labelTN2}</a>
                    <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableInf}>
                      <thead className=''>
                        <tr className=''>
                          <th className=''></th>
                          <th className=''>Clase</th>
                          <th className=''>Servicio</th>
                          <th className=''>Descripción servicio</th>
                        </tr>
                      </thead>
                      <ListaServ list={listServ} handleChangeTar={this.handleChangeTar} imptosCF={imptosCF}/>
                    </table>
                  </div>
                </div>
              }
              <hr></hr>
            </div>
          }
{/* FIN PARA CREAR OS */}
          <div className="ui one column stackable grid">
            <div className="row container">
              <div className="column" width="100%">

                <Button style={this.props.styles.confirmar} type='submit' fluid>
                    AGREGAR
                </Button>
                {
                  this.props.errors.length?<Message negative header="Los siguientes errores:"
                  list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>
  )
}
}

export default compose(
  graphql(queries.query.allTiposOS, {name:'allTiposOS'}),
  graphql(queries.query.allTiUndMat, {name:'allTiUndMat'}),
  graphql(queries.query.allTipoUnd, {name:'allTipoUnd'}),
  graphql(queries.query.allTipoVia, {name:'allTipoVia'}),
  graphql(queries.query.allUndMat, {name:'allUndMat', options: (props) => {return {variables: {}}}}),
  graphql(queries.query.allDirmayor, {name:'allDirmayor', options: (props) => {return {variables: {}}}}),

  graphql(queries.query.allTarifa, {name:'allTarifa', options: (props) => {return {variables: {}}}}),

  graphql(queries.query.allCategOST, {name:'allCategOST'}),

  // graphql(queries.mutation.fecha, {name:'fecha'}),
)(AddCli2)



// export default AddCli2
